import { render, staticRenderFns } from "./btn-add-monthlyfeecredits.vue?vue&type=template&id=652651ae&"
import script from "./btn-add-monthlyfeecredits.vue?vue&type=script&lang=js&"
export * from "./btn-add-monthlyfeecredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports